let config;
/**
 * Инициализирует клиентский конфиг.
 * Нужно вызвать один раз перед инициализацией приложения
 * После инициализации в приложении, конфиг можно получить с помощью метода getConfig
 */
export function initConfig(inputConfig) {
    config = inputConfig;
}
/**
 * Возвращает клиентский конфиг
 */
export function getConfig() {
    return config;
}
